import { orderStatusColor } from '@/features/orders/utils/order-status';
import { useT } from '@/i18n';
import type { OrderStatus } from '@restaurant/api-client';

/**
 * Order status pill - same affordance as `ReservationBadge`: solid semantic
 * colour, white text, an optional chevron when it's a tap target that opens
 * the contextual action popover. Colours come from the shared status palette
 * (`orderStatusColor`: green = done, orange = needs attention, blue = in
 * flight, gray = closed), never ad-hoc hex.
 */
interface OrderBadgeProps {
  status: OrderStatus;
  onClick?: (e: React.MouseEvent) => void;
  testId?: string;
}

function OrderBadge({ status, onClick, testId }: OrderBadgeProps) {
  const t = useT();
  const label = t.orders.status[status];
  const color = orderStatusColor[status];
  const tappable = !!onClick;

  return (
    <button
      type="button"
      onClick={onClick}
      {...(testId ? { 'data-testid': testId } : {})}
      style={{
        fontSize: 11,
        padding: tappable ? '8px 10px 8px 12px' : '8px 12px',
        borderRadius: 10,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        height: 33,
        boxSizing: 'border-box',
        display: 'inline-flex',
        width: 'fit-content',
        alignItems: 'center',
        gap: tappable ? 4 : 0,
        background: color,
        color: 'white',
        border: 'none',
        cursor: tappable ? 'pointer' : 'default',
      }}
    >
      {label}
      {tappable && (
        <i className="f7-icons" style={{ fontSize: 12, lineHeight: 1, width: 12, height: 12 }}>
          chevron_down
        </i>
      )}
    </button>
  );
}

export default OrderBadge;
